import Vue from 'vue';

/** Event bus for sending Infrastructure events. */
const InfrastructureEventBus = new Vue();

export default InfrastructureEventBus;
